module.exports = __webpack_public_path__ + "static/mantawi-a98dbddfadad1efc28c8c5de90aeb9d7.pdf";